import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { mp } from '../../constants/utils';
import ValuePropBase from './ValuePropBase';
import { breakpoints, palette } from '../../constants/styles';
import Helmet from 'react-helmet';
import { StyledResultImageExamplePlan, StyledButtonA, StyledFirstButton } from './ReferralLanding';
import Title from '../shared/Title';
import { PENSION_PLAN_PRICE } from '../../constants/constants';
import Text from '../shared/Text';
import Button from '../shared/Button';

const StyledALink = styled.a`
  width: 250px;
  text-decoration: none;
`;

const StyledTitle = css`
  max-width: 290px;
  color: #022759;

  ${breakpoints.tablet} {
    text-align: center;
    max-width: 430px;
  }

  ${breakpoints.tabletLandscape} {
    text-align: left;
    max-width: 300px;
    margin-bottom: 20px;
  }
`;

const StyledPrice = css`
  font-size: 2.5rem;
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 15px;
`;

const StyledMainTitle = css`
  max-width: 290px;
  line-height: 1.2;
  margin-top: 60px;

  ${breakpoints.tablet} {
    margin-top: 60px;
    text-align: center;
    max-width: 430px;
  }

  ${breakpoints.tabletLandscape} {
    display: none;
    text-align: left;
    max-width: 300px;
  }
  color: ${palette.primaryColor};
  text-align: center;
`;

const styledMessage = css`
  width: 55%;
  text-align: center;
  ${breakpoints.tablet} {
    width: 100%;
  }
  ${breakpoints.tabletLandscape} {
    text-align: left;
    max-width: 134px;
  }
`;

const Retiro = () => (
  <Fragment>
    <Helmet>
      <title>{'Finauta | Retiro'}</title>
    </Helmet>
    <ValuePropBase
      event="Clicked start retirement"
      tool="retiro"
      title="Descubre cuál será tu ingreso en el retiro "
      titleStyles={StyledTitle}
      mainTitle="Calculadora de retiro"
      message="Anónimo y en menos de 1 minuto"
      mainTitleStyles={StyledMainTitle}
      messageStyles={styledMessage}
    >
      <StyledResultImageExamplePlan
        src={`https://s3.us-east-2.amazonaws.com/finauta/products/pdf-preview.png`}
      />
      <Title level={3}>Plan de pensión</Title>
      <Title level={4} light>
        Tu guía para lograr tu retiro ideal
      </Title>
      <Text type="body2">Con base en tu situación, tu plan incluye:</Text>
      <ul>
        <li>
          <Text type="body2">
            Cálculo <u>detallado</u> de <b>con cuánto te retirarás</b> si sigues como vas
          </Text>
        </li>
        <li>
          <Text type="body2">
            Cálculo <u>detallado</u> de 3 escenarios dentro de <b>modalidad 40</b>
          </Text>
        </li>
        <li>
          <Text type="body2">Análisis de costo/beneficio de modalidad 40</Text>
        </li>
        <li>
          <Text type="body2">Riesgos y áreas de oportunidad de tu situación</Text>
        </li>
      </ul>
      <StyledButtonA target="_blank" href="https://www.youtube.com/watch?v=dfs1OF0bSYk">
        <Button
          styles={StyledFirstButton}
          onClick={() => {
            mp('Referrals | CTA | PlanDeEjemplo');
          }}
          color="darkerGray"
        >
          <Text type="buttonText" color="white" bold>
            Ver plan de ejemplo
          </Text>
          {/* <Icon icon="playVideo" color="white" size={25} style={{ marginLeft: '10px' }} /> */}
        </Button>
      </StyledButtonA>
      <StyledALink href="https://www.finauta.com/plan-de-pension">
        <Button
          styles={StyledFirstButton}
          onClick={() => {
            mp('Referrals | CTA | Solicitar plan');
          }}
        >
          <Text type="buttonText" color="white" bold>
            Más información
          </Text>
        </Button>
      </StyledALink>
    </ValuePropBase>
  </Fragment>
);

export default Retiro;
